import { render } from "./TwcButton.vue?vue&type=template&id=e9ef242c&scoped=true"
import script from "./TwcButton.vue?vue&type=script&lang=js"
export * from "./TwcButton.vue?vue&type=script&lang=js"

import "./TwcButton.vue?vue&type=style&index=0&id=e9ef242c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ef242c"]])

export default __exports__